import { render, staticRenderFns } from "./abbreviation.vue?vue&type=template&id=823277be&scoped=true&"
import script from "./abbreviation.vue?vue&type=script&lang=js&"
export * from "./abbreviation.vue?vue&type=script&lang=js&"
import style0 from "./abbreviation.vue?vue&type=style&index=0&id=823277be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823277be",
  null
  
)

export default component.exports